import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modals.data.account_recovery,
    (account_recovery) => {
        return {
            stage: account_recovery.stage,
            data: account_recovery[account_recovery.stage]
        }
    }
)